import { createSelector } from 'reselect';
import queryString from 'query-string';

import { getEntities, selectServiceConfig } from '../../global-selectors';
import { get } from '../../utils/lodash';
import jwtDecode from 'jwt-decode';

export const selectUserData = createSelector(
  getEntities,
  entities => entities.user
);

export const selectUserPaymentMethods = createSelector(
  getEntities,
  entities => entities.userPaymentMethods || []
);


export const selectDeviceCountry = createSelector(
  getEntities,
  entities => get(entities, 'user.ipCountry')
);

export const selectLoginUrl = createSelector(
  selectServiceConfig,
  (serviceConfig) => serviceConfig.pass.loginURL
);

export const selectPopulatedLoginUrl = createSelector(
  selectServiceConfig,
  selectUserData,
  (serviceConfig, user) => {
    const returnUrl = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}`);
    return serviceConfig.pass.loginURL
      .replace('COUNTRY_CODE', user.country)
      .replace('RETURN_URL', returnUrl);
  }
);

export const selectAuth = createSelector(
  selectUserData,
  (user) => !(user && user.noLogged)
);

export const selectIDP = createSelector(
  selectLoginUrl,
  (loginURL) => {
    const [, query] = loginURL.split('?');
    const { idp } = queryString.parse(query);

    return idp;
  }
);

export const selectUserCountry = createSelector(
  selectUserData,
  (user) => user.country
);

export const selectUserDeviceToken = createSelector(
  selectUserData,
  (user) => {
    const decoded = jwtDecode(user.token)
    return decoded.device
  }
);